import { render, staticRenderFns } from "./zone-announcement.vue?vue&type=template&id=3fe449df&scoped=true"
import script from "./zone-announcement.vue?vue&type=script&lang=js"
export * from "./zone-announcement.vue?vue&type=script&lang=js"
import style0 from "./zone-announcement.vue?vue&type=style&index=0&id=3fe449df&prod&lang=css"
import style1 from "./zone-announcement.vue?vue&type=style&index=1&id=3fe449df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe449df",
  null
  
)

export default component.exports